import { z } from 'zod';
import {
    buildRoadMapGoalSlots,
    isValidRoadMapDurationPeriod,
} from './bigdes-road-map.constants.js';

const positiveInt = (requiredKey) => z.coerce.number({
    required_error: requiredKey,
    invalid_type_error: requiredKey,
}).int().positive(requiredKey);

export const RoadMapGoalSchema = z.object({
    index: positiveInt('form.validation.goalIndexRequired'),
    periodEndMonth: positiveInt('form.validation.periodEndMonthRequired'),
    description: z.string({ required_error: 'form.validation.goalDescriptionRequired', invalid_type_error: 'form.validation.goalDescriptionRequired' }).trim().min(1, 'form.validation.goalDescriptionRequired'),
});

const roadMapWorkPackageBaseShape = {
    packageNo: z.string({ required_error: 'form.validation.packageNoRequired', invalid_type_error: 'form.validation.packageNoRequired' }).trim().min(1, 'form.validation.packageNoRequired'),
    name: z.string({ required_error: 'form.validation.nameRequired', invalid_type_error: 'form.validation.nameRequired' }).trim().min(1, 'form.validation.nameRequired'),
    targetDurationMonths: positiveInt('form.validation.targetDurationMonthsRequired'),
    periodMonths: positiveInt('form.validation.periodMonthsRequired'),
    activities: z.string({ required_error: 'form.validation.activitiesRequired', invalid_type_error: 'form.validation.activitiesRequired' }).trim().min(1, 'form.validation.activitiesRequired'),
    goals: z.array(RoadMapGoalSchema).min(1, 'form.validation.goalsRequired'),
};

function validateRoadMapGoals(data, ctx) {
    if (!isValidRoadMapDurationPeriod(data.targetDurationMonths, data.periodMonths)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'form.validation.periodDivisibilityInvalid',
            path: ['periodMonths'],
        });
        return;
    }

    const slots = buildRoadMapGoalSlots(data.targetDurationMonths, data.periodMonths);
    if (!slots.length) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'form.validation.goalSlotsInvalid',
            path: ['goals'],
        });
        return;
    }

    if (data.goals.length !== slots.length) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'form.validation.goalCountMismatch',
            path: ['goals'],
        });
    }
}

export const CreateBigdesRoadMapWorkPackageSchema = z.object(roadMapWorkPackageBaseShape)
    .superRefine(validateRoadMapGoals);

export const UpdateBigdesRoadMapWorkPackageSchema = z.object({
    ...roadMapWorkPackageBaseShape,
    packageNo: roadMapWorkPackageBaseShape.packageNo.optional(),
    name: roadMapWorkPackageBaseShape.name.optional(),
    targetDurationMonths: roadMapWorkPackageBaseShape.targetDurationMonths.optional(),
    periodMonths: roadMapWorkPackageBaseShape.periodMonths.optional(),
    activities: roadMapWorkPackageBaseShape.activities.optional(),
    goals: roadMapWorkPackageBaseShape.goals.optional(),
}).superRefine((data, ctx) => {
    if (
        data.targetDurationMonths != null
        && data.periodMonths != null
        && data.goals != null
    ) {
        validateRoadMapGoals(data, ctx);
    }
});
